import MailModal from "@components/MailModal";
import { useCallback, useEffect, useState } from "react";

import { fetchAttachment } from "./fetchAttachment";

interface MailComposerOptions {
  defaultEmail?: string;
  exportUrl?: string;
}

interface OpenOptions {
  subject: string;
  body: string;
  filename?: string;
  email?: string;
}

export const useMailComposer = ({ defaultEmail, exportUrl }: MailComposerOptions) => {
  const [open, setOpen] = useState(false);
  const [defaults, setDefaults] = useState<OpenOptions>({ subject: "", body: "" });
  const [filename, setFilename] = useState("report.xlsx");
  const [emailOverride, setEmailOverride] = useState<string | undefined>(defaultEmail);

  useEffect(() => {
    if (!open) {
      setEmailOverride(defaultEmail);
    }
  }, [defaultEmail, open]);

  const handleOpen = useCallback(
    ({ subject, body, filename: name, email }: OpenOptions) => {
      setDefaults({ subject, body });
      setFilename(name ?? "report.xlsx");
      setEmailOverride(email ?? defaultEmail);
      setOpen(true);
    },
    [defaultEmail],
  );

  const attachmentsFactory = useCallback(() => {
    if (!exportUrl) {
      throw new Error("Экспорт недоступен");
    }
    return fetchAttachment(exportUrl, filename);
  }, [exportUrl, filename]);

  const modal = (
    <MailModal
      open={open}
      onClose={() => setOpen(false)}
      defaultEmail={emailOverride ?? defaultEmail}
      defaultSubject={defaults.subject}
      defaultBody={defaults.body}
      getAttachments={exportUrl ? attachmentsFactory : undefined}
    />
  );

  return {
    openComposer: handleOpen,
    mailModal: modal,
    sendDisabled: !exportUrl,
  };
};
